import type { FC } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Recommended reading`,
}

const cards = [
  {
    title: `7 Steps to Omnichannel Success`,
    description: `This guide offers a firsthand look at how to build an effective omnichannel marketing strategy for your business.`,
    url: `https://learn.segment.com/7-steps-to-omnichannel-success/?utm_source=content&utm_medium=referral&utm_campaign=all_cnt_7-steps-to-omnichannel-success_`,
  },
  {
    title: `Cookies, Compliance, and Customer Data`,
    description: `In this guide, we show the difference between first-party and third-party data, and how it affects marketers.`,
    url: `https://learn.segment.com/cookies-compliance-customer-data/?utm_source=content&utm_medium=referral&utm_campaign=all_cnt_cookies-compliance-customer-data_`,
  },
]

const RecommendedReading: FC = () => (
  <StyledSectionBase variant="centered">
    <Section.Copy>
      <Heading variant="h2" tag="h3">
        {copy.heading}
      </Heading>
    </Section.Copy>
    <Section.Contents>
      <ColumnTrack columns={1} overrides={{ sm: 2 }}>
        {cards.map((card) => (
          <CardBase key={card.title} href={card.url}>
            <Card.Body>
              <Card.Copy>
                <Card.Headline>{card.title}</Card.Headline>
                <Card.Description variant="pLarge">{card.description}</Card.Description>
              </Card.Copy>
              <Card.Action alignment="right">
                <ChevronRightIcon />
              </Card.Action>
            </Card.Body>
          </CardBase>
        ))}
      </ColumnTrack>
    </Section.Contents>
  </StyledSectionBase>
)

export default RecommendedReading

const Heading = styled(Typography)`
  margin: 0;
`

const StyledSectionBase = styled(SectionBase)`
  max-width: 1000px;
`
